Recycler = function() { Model.call(this); };

Recycler.prototype             = new Model();
Recycler.prototype.constructor = Recycler;

Recycler.prototype.get_infos = function(recycler_id, callbacks)
{
    this.ajax({
        url:       'recycler/index/'+recycler_id,
        type:      'GET',
        dataType:  'json',
        callbacks: callbacks
    });
};

Recycler.prototype.set_url = function(recycler_id, url, callbacks)
{
    this.ajax({
        url:       'recycler/save/'+recycler_id,
        type:      'POST',
        dataType:  'json',
        data: { url : url},
        callbacks: callbacks
    });
};

Recycler.prototype.set_email = function(recycler_id, email, callbacks)
{
    this.ajax({
        url:       'recycler/save/'+recycler_id,
        type:      'POST',
        dataType:  'json',
        data: { email : email},
        callbacks: callbacks
    });
};

Recycler.prototype.set_force_payment = function(recycler_id, force_payment, callbacks) {
    this.ajax({
        url:       'recycler/save/'+recycler_id,
        type:      'POST',
        dataType:  'json',
        data: { force_payment: force_payment },
        callbacks: callbacks
    });
};